type Props = {
	timestamp: Date;
	className?: string;
};

export const ShortDate = ({ timestamp, className = '' }: Props) => {
	return <time className={className}>{timestamp.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</time>;
};
